import React from "react";
import { motion } from "framer-motion";
import { LANDING } from "@/constants/testIds";

const CARD_IMG =
  "https://customer-assets.emergentagent.com/job_acf17a54-a448-40a0-9a51-eb2d6ba03f53/artifacts/hq5mvsj0_IMG_20260628_211219.png";

// Showcases the real before/after photo from the business card inside a glowing frame.
export const BeforeAfterShowcase = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, delay: 0.1 }}
      className="relative w-full"
    >
      <div
        className="absolute -inset-4 rounded-[28px] opacity-60 blur-2xl"
        style={{ background: "radial-gradient(60% 60% at 50% 40%, rgba(59,155,232,0.35), rgba(7,11,20,0))" }}
        aria-hidden="true"
      />
      <div className="relative rounded-2xl overflow-hidden border border-[#3B9BE8]/30 shadow-[0_0_0_1px_rgba(59,155,232,0.22),0_24px_70px_rgba(0,0,0,0.55)] bg-[#0B1224]">
        <img
          data-testid={LANDING.heroShowcase}
          src={CARD_IMG}
          alt="Koehn Headlight Restoration — before and after of a foggy headlight restored crystal-clear"
          className="w-full h-auto block select-none"
          loading="eager"
        />
      </div>
      <div className="mt-3 flex items-center justify-center gap-2 text-xs text-white/55">
        <span className="inline-block h-2 w-2 rounded-full bg-[#3B9BE8]" />
        Real result — actual customer headlight
      </div>
    </motion.div>
  );
};
